import { Helper } from "../../helpers/helper";
import { TelerikUtility } from "../telerik.utility";

function toggleByExpectedValues(jValueElement: JQuery, jTargetElement: JQuery, expectedValues: any[], ignoreRequiredCheck = false, fieldContainerSelector: any = ".PanelField") {
    let elementValue = getValueByType(jValueElement);
    let isShow = expectedValues.includes(elementValue);

    showField(jTargetElement, isShow, isShow, ignoreRequiredCheck, fieldContainerSelector);
    return isShow;
}

function showField(jElement: JQuery, showField: boolean, enableValidation: boolean, ignoreRequiredCheck = false, fieldContainerSelector: any = ".PanelField") {
    // evaluate the container for the field to hide
    let jElementContainer = jElement.closest(fieldContainerSelector);
    if (showField) {
        jElementContainer.show();
    } else {
        // reset the value on hide
        resetValue(jElement);
        jElementContainer.hide();
    }

    if (enableValidation != null) {
        toggleValidators(jElement, enableValidation, ignoreRequiredCheck, fieldContainerSelector);
    }
}

function toggleValidators(jElement: JQuery, enable: boolean, ignoreRequiredCheck = false, fieldContainerSelector: any = ".PanelField") {
    // only enable field validators if the field is originally required
    // this may not be retrievable from the elment directly and might be on the parent element (i.e. for dates with wrappers)
    let dataObject = Object.assign({}, jElement.data(), jElement.parent().data());
    if (dataObject.required || ignoreRequiredCheck) {
        // we have to get validators by finding the closest PanelFieldValue element and using that to get all ValidationError classed elements
        let validators = jElement.closest(fieldContainerSelector).find(".ValidationError");
        validators.each(function () {
            window.ValidatorEnable(this, enable);
        });

        if (validators.length > 0) {
            // find the nearest label and toggle the required class
            let jLabel = jElement.closest(fieldContainerSelector).find("label");
            if (enable) {
                jLabel.addClass("Required");
            } else {
                jLabel.removeClass("Required");
            }
        }
    }
}

function resetValue(jElement: JQuery) {
    // ensure the element is not a telerik control
    let elementId = jElement.attr("id");
    let tElement: Telerik.Web.UI.RadWebControl = $find(elementId);
    if (tElement == null) {
        jElement.val("");
        
        // covers checkboxes
        jElement.prop("checked", false);
    } else {
        // clear the value of the telerik control based on the method available
        if (tElement["clear"] != null) {
            tElement["clear"]();   
        } else if (tElement["clearSelection"] != null) {
            tElement["clearSelection"]();
        }
    }
}

function setDefaultValue(elementSelector: any, defaultValue: any) {
    let jElement = jQuery(elementSelector);
    let value = getValueByType(jElement);
    if (Helper.isStringNullOrEmpty(value)) {
        setValueByType(jElement, defaultValue);
    }
}

function getValueByType(jElements: JQuery<HTMLElement>) {
    let value: any;

    if (isFormElementTypeText(jElements)) {
        // ensure whether text control is Telerik or not
        let tElement: Telerik.Web.UI.RadWebControl = $find(jElements.attr("id"));
        if (tElement != null) {
            value = TelerikUtility.getTelerikControlValue(tElement);
        } else {
            value = jElements.val();
        }
    } else if (isFormElementTypeRadio(jElements)) {
        // this could possibly involve more than one radio button, filter out the unchecked ones and get the value
        value = jElements.filter(":checked").val();
    } else {
        value = jElements.prop("checked");
    }

    return value;
}

function setValueByType(jElements: JQuery<HTMLElement>, newValue: any) {
    // this works for a select tag too because it will be null
    if (isFormElementTypeText(jElements)) {
        // ensure whether text control is Telerik or not
        let tElement: Telerik.Web.UI.RadWebControl = $find(jElements.attr("id"));
        if (tElement != null) {
            TelerikUtility.setTelerikControlValue(tElement, newValue);
        } else {
            jElements.val(newValue);
        }
    } else if (isFormElementTypeRadio(jElements)) {
        // this could possible involve more than one radio element, select the one with the matching value
        jElements.filter(`[value=${newValue}]`).prop("checked", true);
    } else {
        jElements.prop("checked", newValue);
    }
}

function isFormElementTypeText(jElement: JQuery<HTMLElement>): boolean {
    let type = jElement.attr("type");
    return !["checkbox", "radio"].includes(type);
}

function isFormElementTypeRadio(jElement: JQuery<HTMLElement>): boolean {
    let type = jElement.attr("type");
    return type == "radio";
}

export {
    setDefaultValue,
    getValueByType,
    setValueByType,
    resetValue,
    toggleByExpectedValues,
    toggleValidators,
    showField,
};
